import { Expose } from 'class-transformer'

export class BookCountByUserType {
  @Expose() publishedCount: number

  @Expose() draftCount: number
}
